__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@lmn/cia-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@sentry/react", "10.53.1", () => (Promise.all([__webpack_require__.e(3391), __webpack_require__.e(8437)]).then(() => (() => (__webpack_require__(93391))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(8437)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router", "7.15.1", () => (Promise.all([__webpack_require__.e(5997), __webpack_require__.e(8437)]).then(() => (() => (__webpack_require__(65997))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("styled-components", "6.4.2", () => (Promise.all([__webpack_require__.e(882), __webpack_require__.e(8437)]).then(() => (() => (__webpack_require__(882))))));
			initExternal(70798);
			initExternal(50460);
			initExternal(90576);
			initExternal(96514);
			initExternal(7644);
			initExternal(8928);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};